import { Trash2 } from 'lucide-react'

export default function ConfirmDialog({ title, message, onConfirm, onCancel, loading }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.35)' }}
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm rounded-2xl p-6 flex flex-col gap-4"
        style={{ background: 'var(--surface)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-lg)' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: 'var(--danger-tint)' }}>
            <Trash2 size={18} style={{ color: 'var(--danger)' }} />
          </div>
          <div>
            <p className="font-semibold text-[14px] m-0" style={{ color: 'var(--ink)' }}>
              {title || "O'chirishni tasdiqlang"}
            </p>
            <p className="text-[12.5px] m-0 mt-0.5" style={{ color: 'var(--ink-3)' }}>
              {message || "Bu amalni qaytarib bo'lmaydi."}
            </p>
          </div>
        </div>

        <div className="flex gap-2 justify-end">
          <button
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 rounded-xl text-[13px] font-semibold border transition-all"
            style={{ background: 'var(--surface)', borderColor: 'var(--border)', color: 'var(--ink-2)' }}
          >
            Bekor qilish
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 rounded-xl text-[13px] font-semibold transition-all"
            style={{ background: 'var(--danger)', color: '#fff', opacity: loading ? 0.6 : 1 }}
          >
            {loading ? "O'chirilmoqda..." : "O'chirish"}
          </button>
        </div>
      </div>
    </div>
  )
}
